export default function filterFormValues(filterKey, values) {
  return Object.keys(values)
    .filter(key => {
      return key.includes(filterKey);
    })
    .reduce((cur, key) => {
      return Object.assign(cur, {
        [key]:
          !isNaN(parseFloat(values[key])) && !key.includes("include")
            ? parseFloat(values[key]).toFixed(2)
            : values[key],
      });
    }, {});
}
